import React from 'react';
import Contact from '../components/Contact';

const ContactPage: React.FC = () => {
  return (
    <div className="min-h-screen pt-16 md:pt-20">
      <Contact />
    </div>
  );
};

export default ContactPage;
